export default {
  EmptyState: {
    title: 'Füge dein erstes Restaurant hinzu',
    description:
      'Du hast noch keine Restaurants. Lege eines an, um mit der Einrichtung zu beginnen und Bestellungen anzunehmen.',
    cta: 'Neues Restaurant',
  },
};
